import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Input, Button, Tooltip, Table } from "antd";
import "../../styles/filters-form.less";
import "./BillFactur.less";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { fetchSequence, updateSequence } from "../../store/slices/rtkDictionaries";
import tickIcon from "../../img/done.svg";
import deleteIcon from "../../img/delete-round.svg";
import edit from "../../img/edit.svg";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_BILLING_ACCOUNTINGSYSTEM_WRITE } from "../../lib/const/permissions";

const BillFactur = ({ sequence, sequenceLoading }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [editingKey, setEditingKey] = useState(null);
  const [nextValue, setNextValue] = useState("");
  const isEditing = (rec) => rec.key === editingKey;
  const [editStatus, setEditStatus] = useState("");
  const isEditingForce = editStatus === "editingForce";

  useEffect(() => {
    setData(
      sequence &&
        sequence.map((item, index) => ({
          key: index,
          seqName: item.seqName,
          dsc: item.dsc,
          nextValue: item.nextValue,
        }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequence]);

  const columns = [
    {
      title: "Название последовательности",
      dataIndex: "seqName",
      key: "seqName",
      width: "30%",
    },
    {
      title: "Комментарий",
      dataIndex: "dsc",
      key: "dsc",
      width: "30%",
    },
    {
      title: "Следующее значение",
      dataIndex: "nextValue",
      key: "nextValue",
      width: "30%",
      render: (val, record) => {
        const editable = isEditing(record);
        const onChangeValue = (e) => {
          const { value } = e.target;
          setNextValue(value);
        };
        return editable && isEditingForce ? (
          <>
            <Input placeholder="Введите значение" defaultValue={val} onChange={onChangeValue} />
          </>
        ) : (
          <>{val}</>
        );
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      render: (val, record) => {
        const editable = isEditing(record);
        const disabled = isEditingForce;
        const disabledEdit = disabled && !nextValue;

        // eslint-disable-next-line no-shadow
        const handleEdit = (editStatus) => {
          setEditingKey(() => record.key);
          setEditStatus(editStatus);
          setNextValue(record.nextValue);
        };

        const handleCancel = () => {
          setEditStatus("");
          setEditingKey(null);
          setNextValue("");
        };

        const handleSubmit = async () => {
          if (isEditingForce) {
            await dispatch(
              updateSequence({
                seqName: record.seqName,
                nextValue,
              })
            );
          }

          await dispatch(fetchSequence());
          setEditingKey(null);
          setEditStatus("");
          setNextValue("");
        };
        if (hasAccess(MENU_BILLING_ACCOUNTINGSYSTEM_WRITE)) {
          return editable && isEditingForce ? (
            <>
              <Tooltip title={`${disabledEdit ? "Заполните все поля" : "Подтвердить изменения"}`}>
                <Button
                  icon={<img src={tickIcon} alt="tick" width="16px" />}
                  className="icon"
                  type="text"
                  htmlType="button"
                  onClick={() => handleSubmit()}
                  disabled={disabledEdit}
                />
              </Tooltip>
              <Tooltip title="Отменить">
                <Button
                  icon={<img src={deleteIcon} width="16px" alt="delete" />}
                  type="text"
                  className="icon"
                  htmlType="button"
                  onClick={() => handleCancel()}
                />
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="Редактировать">
                <Button
                  icon={<img src={edit} alt="pencil" width="16px" />}
                  type="text"
                  htmlType="button"
                  disabled={disabled}
                  onClick={() => handleEdit("editingForce")}
                />
              </Tooltip>
            </>
          );
        }
        return null;
      },
    },
  ];

  return (
    <>
      <h3 className="invoice-period-header">Установка нумерации счетов-фактур</h3>
      <Table
        size="small"
        className="bill-factur-table"
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={checkIsLoading(sequenceLoading)}
      />
    </>
  );
};

export default BillFactur;
